export * from './delete-ort-kategorie.service';
export * from './delete-ort-kategorie.service.module';